<template>
	<div class="fixed inset-0 flex items-center justify-center bg-trans-gray z-20" v-show="show">
		<div class="rounded shadow bg-white w-full mx-1 sm:w-1/3">
			<div class="rounded-t bg-gray-800 px-4 py-4 text-white font-thin text-lg">
				Update Pricing: {{ product.name }}
			</div>
			<div class="p-4">
				<div class="flex flex-wrap items-center mr-2 mb-2" v-for="(supplier, index) in update">
					<label class="flex-1 block mr-4 text-gray-700 text-sm mb-1">{{ supplier.name }}</label>
					<input class="w-32 appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" :class="{'border-red-500' : priceError.includes(index)}" type="text" :value="supplier.price | toNumber" @input="changeValue(index, $event)" placeholder="">
					<p class="w-full text-red-500 text-xs italic mt-1 text-right" v-if="priceError.includes(index)">Please enter valid amount</p>
				</div>
			</div>
			<div class="rounded-b bg-gray-200 px-4 py-2">
				<div class="flex items-center justify-between">
					<action-button class="link" @button-clicked="cancel">cancel</action-button>
					<action-button class="btn btn-blue" @button-clicked="save">Send</action-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	props: ['show', 'initialProduct'],
	data () {
		return {
			priceError: [],
			product: this.initialProduct,
			update: {},
		}
	},
	filters:{
		toNumber: function(value){
			let val = value/100;
			return val === 0 ? null : val;
		}
	},
	methods: {
		changeValue: function(index, event){
			this.$set(this.update[index],'price', event.target.value*100);
		},
		cancel () {
			this.$emit('close')
		},
		save () {
			this.priceError = [];
			let postData = {
				product_id: this.product.id,
				pricing: []
			}
			Object.keys(this.update).forEach((key,index) => {
				if(this.update[key].price !== 0 && this.update[key].price !== null && this.update[key].price !== '' && !isNaN(this.update[key].price)){
					postData.pricing.push({
						supplier_id: this.update[key].id,
						price: this.update[key].price,
					})
				}else if(!typeof this.update[key].price == 'number' && !this.update[key].price.isInteger()){
					this.priceError.push(index);
				}
			});
			if(this.priceError.length) return;
			this.$http.post(`price/`, postData)
				.then(response => {
					let success = {
						title: 'Action Successful',
						message: 'Pricing updated successfully!',
						type: 'success'
					}
					this.$store.commit('setStatus', success)	
					this.$emit('reload')
					this.$emit('close')
				})
				.catch(err => {
					let success = {
						title: 'Fail',
						message: 'Pricing was not updated',
						type: 'error'
					}
				})
		},
		getSuppliersByCategory(suppliers,catId){
			var result = {}, key, key1;
			for (key in suppliers) {
				if (suppliers.hasOwnProperty(key)) {
					for (key1 in suppliers[key].categories)
					{
						if(suppliers[key].categories[key1].id == catId)
						{
							result[key] = suppliers[key];
						}
					}
					
				}
			}
			return result;
		},
	},
	computed: {
		
	},
	components: {
		
	},
	watch: {
		show: {
			immediate: true,
			handler: show => {
				if (show) {
					document.body.style.setProperty('overflow', 'hidden')
				} else {
					document.body.style.removeProperty('overflow')
				}
			}
		}
	},
	created () {
		const listener = document.addEventListener('keydown', e => {
			if (this.show && e.keyCode === 27) {
				this.cancel()
			}
		})

		this.$once('hook:beforeDestroy', () => {
			document.removeEventListener('keydown', listener)
			document.body.style.removeProperty('overflow')
		});
		
		this.$http.get(`price/${this.product.id}`)
			.then(response => {
				// this.update = response.data.suppliers;
				this.update = this.getSuppliersByCategory(response.data.suppliers,response.data.category_id);
			})
			.catch(err => {
				let error = {
					title: 'Fail',
					message: 'Unable to load supplier info',
					type: 'error'
				}
				this.$store.commit('setStatus', error)	
			});
	}
}
</script>
